.pdpReviewStarsContainer {
  display: flex;
  margin-top: 8px;
  flex-direction: row;
  align-items: center;
}
